import { useQuery } from '@tanstack/react-query'
import apiClient from '@/lib/apiClient'

export interface TenantMetrics {
  revenue: string
  revenue_count: number
  purchases: string
  collected: string
  outstanding: string
  overdue: string
  customers_active: number
  suppliers_active: number
  trend_6m: { month: string; revenue: string; purchases: string; collected: string }[]
}

export interface ConsolidatedTenant {
  schema: string
  name: string
  currency: string
  rate_to_target: string
  metrics: TenantMetrics
  metrics_converted: TenantMetrics
}

export interface ConsolidatedData {
  period: { date_from: string; date_to: string }
  target_currency: string
  tenants_count: number
  summary: TenantMetrics
  by_tenant: ConsolidatedTenant[]
}

export function useConsolidatedMetrics(params?: {
  date_from?: string
  date_to?: string
  currency?: string
}) {
  return useQuery<ConsolidatedData>({
    queryKey: ['platform', 'consolidated', params],
    queryFn: async () => {
      const res = await apiClient.get('/platform/consolidated/', { params })
      return res.data
    },
  })
}
